<form nz-form style="padding-top:12px;padding-right:12px" class="detail-mail" autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
    <div nz-col nzSm="4" nzMd="4" *ngIf="value.tagName">
      <nz-tag [nzColor]="value.color">
        <i nz-icon nzType="tag" nzTheme="outline"></i>
        <span>
          {{ value.tagName }}
        </span>
      </nz-tag>
    </div>
    <div nz-col nzSm="4" nzMd="4" *ngIf="!value.tagName">
    </div>
    <div nz-col nzSm="20" nzMd="20" class="group-button">
      <ng-container *ngIf="value.source === 'Inbox'">
        <page-btn-option-extend [buttonList]="pageOptBtn_1">
        </page-btn-option-extend>
      </ng-container>
      <page-btn-option-extend [buttonList]="pageOptBtn_2">
      </page-btn-option-extend>
      <ng-container *ngIf="mode !== 'deleted'">
        <page-btn-option-extend [buttonList]="pageOptBtn_3">
        </page-btn-option-extend>
      </ng-container>
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-card class="mail-card">
        <div nz-row [nzGutter]="['24','12']">
          <div nz-col [nzSm]="24" [nzMd]="24">
            <nz-form-item>
              <span class="content title title-text">{{ mailDetail.subject }}</span>
            </nz-form-item>
          </div>
          <nz-divider></nz-divider>
          <div nz-col nzSm="16" nzMd="16">
            <nz-form-item>
              <nz-avatar nzIcon="user" [nzSrc]="userInfo.avatar"></nz-avatar>
              <div class="content-user">
                {{mailDetail.fromName}}
                <div class="flex">
                  <span>
                    tới {{ mailDetail.listToAsString }}
                  </span>
                  <i nz-icon nzType="caret-down" nzTheme="fill" nz-popover [nzPopoverContent]="contentTemplate"
                    nzPopoverTrigger="click" nzPopoverPlacement="rightTop" style="cursor: pointer;"></i>
                </div>
              </div>
            </nz-form-item>
          </div>
          <div nz-col nzSm="8" nzMd="8" class="flex justify-end">
            <nz-form-item>
              <span *ngIf="mode !== 'draft'" class="content grey">{{mailDetail.time | convertDate: true}}</span>
            </nz-form-item>
          </div>
          <nz-divider></nz-divider>
          <div nz-col nzSm="24" nzMd="24" [innerHTML]="mailDetail.body">
          </div>
          <nz-divider></nz-divider>
          <div nz-col nzSm="24" nzMd="24">
            <span class="text-file">Đính kèm&nbsp;({{fileList.length}})</span>
          </div>
          <div nz-col nzSm="24" nzMd="24">
            <nz-upload [nzFileList]="fileList" [nzShowButton]="false"
              [nzShowUploadList]="{ showRemoveIcon: false, showDownloadIcon : true }" [nzDownload]="downloadfile">
              <button nz-button><i nz-icon nzType="upload"></i>Upload</button>
            </nz-upload>
          </div>
        </div>
      </nz-card>
    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button (click)="close()">Đóng</button>
  </div>
</form>
<ng-template #contentTemplate>
  <div nz-row [nzGutter]="['24','12']" style="width: 500px;">
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label style="font-weight: bold;">Chủ đề</nz-form-label>
        <span style="display: flex; align-items: center;">{{mailDetail.subject}}</span>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label style="font-weight: bold;">Người gửi</nz-form-label>
        <span style="display: flex; align-items: center;">{{mailDetail.fromName}}</span>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label style="font-weight: bold;">Người nhận</nz-form-label>
        <span style="display: flex; align-items: center;">{{mailDetail.listToAsString}}</span>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label style="font-weight: bold;">Cc</nz-form-label>
        <span style="display: flex; align-items: center;">{{mailDetail.listCcAsString}}</span>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label style="font-weight: bold;">Thời gian</nz-form-label>
        <span *ngIf="mode !== 'draft'" style="display: flex; align-items: center;">{{mailDetail.time | convertDate:
          true}}</span>
      </nz-form-item>
    </div>
  </div>
</ng-template>
<ng-template #tplTitle>
  <div class="flex justify-between">
    <span>{{ titlePopup }}</span>
    <button nz-button class="btn-modal-reside" (click)="handlerResizePopup()">
      <i nz-icon [nzType]="!isResizdePopup ? 'arrows-alt': 'shrink'" nzTheme="outline"></i>
    </button>
  </div>
</ng-template>
